export const SHARE_TITLE = 'ReadTheWord';
export const SHARE_TEXT = 'Reading the Bible together this season.';

/**
 * Share the site so the live score image travels with the link.
 * Uses the system share sheet when the browser offers one. A dismissed sheet
 * stays dismissed. Anything else copies the link.
 */
export async function shareSite({ url, share, writeText }) {
  if (share) {
    try {
      await share({ title: SHARE_TITLE, text: SHARE_TEXT, url });
      return 'shared';
    } catch (error) {
      if (error?.name === 'AbortError') return 'cancelled';
    }
  }

  if (writeText) {
    await writeText(url);
    return 'copied';
  }

  return 'failed';
}
